module.exports = __webpack_public_path__ + "img/Matias.c179aea2.jpg";